import React from "react";
import { useTranslation } from "react-i18next";
import "./RefuseManagerModal.less";

type RefuseManagerModalProps = {
  onClose: () => void;
  onRefuse: () => void;
};

const RefuseManagerModal: React.FC<RefuseManagerModalProps> = ({ onClose, onRefuse }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="manager-modal-overlay" onClick={handleOverlayClick}>
      <div className="manager-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="manager-modal-container">
          <div className="manager-modal-title">{t("confirm-refuse-manager-title")}</div>
          <button className="manager-modal-refuse-button" onClick={onRefuse}>
            {t("i-refuse")}
          </button>
          <button className="manager-modal-cancel-button" onClick={onClose}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefuseManagerModal;
